import { BaseInquiryStatus } from 'base';

export const INQUIRY_ACTIONS_MAP: Record<string, Record<number, string[]>> = {
  canPublish: {
    [BaseInquiryStatus.unpublished]: ['action.close', 'action.publish', 'action.edit'],
    [BaseInquiryStatus.closed]: ['action.publish'],
    [BaseInquiryStatus.published]: ['action.close'],
  },
  canClose: {
    [BaseInquiryStatus.unpublished]: ['action.close', 'action.edit'],
    [BaseInquiryStatus.published]: ['action.close'],
  },
};
